import React from "react";

import Heading from "@common/components/Heading/Heading";
import Paragraph from "@common/components/Paragraph/Paragraph";
import { PlatformName } from "@common/models";
import { useAppSelectionContext } from "@main/context/App/AppSelectionContext";
import * as MetricDetailsStyled from "main/pages/Release/views/MetricDetails/MetricDetails.styles";

export default function AppHangFreeSessionsAboutView() {
  const { selectedApp } = useAppSelectionContext();

  return (
    <div style={{ padding: "3.2rem 0" }}>
      <MetricDetailsStyled.MetricsCard>
        <Heading
          heading3
          marginBottom={24}
        >
          About
        </Heading>
        <Heading
          heading4
          marginBottom={16}
          fontWeight={"bold"}
        >
          What it measures
        </Heading>
        <Paragraph
          p1
          marginBottom={24}
        >
          {`The percentage of user sessions that didn't experience ${
            selectedApp?.platform?.name === PlatformName.ANDROID ? "app not responding (ANR)" : "an app hang"
          } — the main thread freezing and failing to respond.`}
        </Paragraph>

        <Heading
          heading4
          marginBottom={16}
          fontWeight={"bold"}
        >
          Why it matters
        </Heading>
        <Paragraph
          p1
          marginBottom={24}
        >
          {
            "A hang doesn't crash the app, but users experience it the same way — frozen UI, dead taps. It's a top driver of bad reviews and silent churn, and it's invisible to dashboards that only track crashes."
          }
        </Paragraph>

        <Heading
          heading4
          marginBottom={16}
          fontWeight={"bold"}
        >
          How to use it
        </Heading>
        <Paragraph
          p1
          marginBottom={24}
        >
          {
            "Hang reports include the main thread's stack trace, grouped and de-symbolicated like crash reports. Follow the link to open the Crashes module and isolate what's blocking the main thread."
          }
        </Paragraph>
      </MetricDetailsStyled.MetricsCard>
    </div>
  );
}
